import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-navy bg-noise flex flex-col relative overflow-hidden selection:bg-red/30 selection:text-cream" data-id="element-0">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-1">
        {/* Soft radial gradient for vignette effect */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(26,79,156,0.7)_100%)]" data-id="element-2"></div>

        {/* Subtle glowing orbs */}
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-red/5 blur-[120px]" data-id="element-3"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-mocha/40 blur-[150px]" data-id="element-4"></div>
      </div>

      <Header data-id="element-5" />
      <Hero data-id="element-6" />
      <Features data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}